import axios, { AxiosResponse } from 'axios';
import { Color } from 'src';
import { reportErrorSentry } from 'src/bff';
import { getDataUrlWithoutTenant } from '../get-data-url';

interface ColoresRequest {
  colores: Color[];
}

export const getColors = async () => {
  const dataUrl = getDataUrlWithoutTenant();
  // const dataUrl = 'https://pre-data-01.volkswagen.es/api';

  try {
    const response: AxiosResponse<ColoresRequest> = await axios.get(`${dataUrl}/getColores`);
    return response.data;
  } catch (err) {
    reportErrorSentry(err);
    return null;
  }
};
